"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTechnicianApiClient = createTechnicianApiClient;
const index_const_1 = require("../index.const");
const infra_1 = require("../infra");
const axios_client_1 = require("@invivodf/axios-client");
function createTechnicianApiClient(apiHost, options) {
    const logger = options.logger ?? index_const_1.NOOP_LOGGER;
    const client = (0, axios_client_1.createAxiosClient)(apiHost, options);
    async function fetchTechnicianByPartnerIdAndTechnicianId(partnerId, technicianId) {
        try {
            const response = await client.get(`/v1/partners/${partnerId}/technicians/${technicianId}`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    async function fetchTechnicianStores(request) {
        try {
            const response = await client.get(`/v1/partners/${request.partnerId}/technicians/${request.technicianId}/stores`);
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, infra_1.handleError)(err);
        }
    }
    return {
        fetchTechnicianStores,
        fetchTechnicianByPartnerIdAndTechnicianId
    };
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGVjaG5pY2lhbnMuY2xpZW50LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3RlY2huaWNpYW5zL3RlY2huaWNpYW5zLmNsaWVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQVdBLDhEQW9DQztBQTdDRCxnREFBMkM7QUFDM0Msb0NBQXNDO0FBQ3RDLHlEQUE4RTtBQU85RSxTQUFnQix5QkFBeUIsQ0FBQyxPQUFlLEVBQUUsT0FBMkI7SUFDcEYsTUFBTSxNQUFNLEdBQUcsT0FBTyxDQUFDLE1BQU0sSUFBSSx5QkFBVyxDQUFBO0lBRTVDLE1BQU0sTUFBTSxHQUFHLElBQUEsZ0NBQWlCLEVBQUMsT0FBTyxFQUFFLE9BQU8sQ0FBQyxDQUFBO0lBRWxELEtBQUssVUFBVSx5Q0FBeUMsQ0FDdEQsU0FBaUIsRUFDakIsWUFBb0I7UUFFcEIsSUFBSSxDQUFDO1lBQ0gsTUFBTSxRQUFRLEdBQUcsTUFBTSxNQUFNLENBQUMsR0FBRyxDQUFnQixnQkFBZ0IsU0FBUyxnQkFBZ0IsWUFBWSxFQUFFLENBQUMsQ0FBQTtZQUN6RyxPQUFPLFFBQVEsQ0FBQyxJQUFJLENBQUE7UUFDdEIsQ0FBQztRQUFDLE9BQU8sR0FBRyxFQUFFLENBQUM7WUFDYixJQUFJLEdBQUcsWUFBWSxLQUFLO2dCQUFFLE1BQU0sQ0FBQyxLQUFLLENBQUMsSUFBSSxFQUFFLEdBQUcsQ0FBQyxLQUFLLENBQUMsQ0FBQTtZQUN2RCxJQUFBLG1CQUFXLEVBQUMsR0FBRyxDQUFDLENBQUE7UUFDbEIsQ0FBQztJQUNILENBQUM7SUFFRCxLQUFLLFVBQVUscUJBQXFCLENBQUMsT0FBb0Q7UUFDdkYsSUFBSSxDQUFDO1lBQ0gsTUFBTSxRQUFRLEdBQUcsTUFBTSxNQUFNLENBQUMsR0FBRyxDQUMvQixnQkFBZ0IsT0FBTyxDQUFDLFNBQVMsZ0JBQWdCLE9BQU8sQ0FBQyxZQUFZLFNBQVMsQ0FDL0UsQ0FBQTtZQUNELE9BQU8sUUFBUSxDQUFDLElBQUksQ0FBQTtRQUN0QixDQUFDO1FBQUMsT0FBTyxHQUFHLEVBQUUsQ0FBQztZQUNiLElBQUksR0FBRyxZQUFZLEtBQUs7Z0JBQUUsTUFBTSxDQUFDLEtBQUssQ0FBQyxJQUFJLEVBQUUsR0FBRyxDQUFDLEtBQUssQ0FBQyxDQUFBO1lBQ3ZELElBQUEsbUJBQVcsRUFBQyxHQUFHLENBQUMsQ0FBQTtRQUNsQixDQUFDO0lBQ0gsQ0FBQztJQUlELE9BQU87UUFDTCxxQkFBcUI7UUFDckIseUNBQXlDO0tBQzFDLENBQUE7QUFDSCxDQUFDIn0=